module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-up-f255a261358faffa01b5767eb40deb17.svg";